import type {Dispatch, FC} from 'react';
import { useCallback} from 'react'
import type {DataTableState} from './dt-types'
import type {Resolvable} from '../../util/resolvable';
import { resolveValue} from '../../util/resolvable'
import {rangeInclusive} from '../../util/collections'
import {NOOP} from '../../helpers/constants'
import {withClass} from '../../helpers/react-helpers'
import ActionLink from '../ActionLink'

export const PAGE_OPTIONS = [10, 20, 30, 50]
const PaginateButton = withClass(ActionLink, 'paginate_button')
export const DataTable_Paginate: FC<{ state: DataTableState, mergeState: Dispatch<Partial<DataTableState>> }> = ({
    state,
    mergeState
}) => {
    const endIndex = state.recordsFiltered ? Math.floor((state.recordsFiltered - 1) / state.pageLength) : 0
    const firstPageNumber = Math.max(1, Math.min(state.startIndex - 1, endIndex - 3))
    const lastPageNumber = Math.min(firstPageNumber + 4, endIndex + 1)

    const setStartIndex = useCallback((cb: Resolvable<number, [number]>) => () => mergeState({startIndex: resolveValue(cb, state.startIndex)}), [mergeState, state.startIndex])

    if(!endIndex && !state.startIndex) return null

    // TODO: make "Prev" go the last available page when startIndex > endIndex

    return (
        <div className="dataTables_paginate">
            <PaginateButton className={{previous: true}}
                disabled={state.startIndex <= 0}
                onClick={setStartIndex(state.startIndex > endIndex ? endIndex : p => p - 1)}>Previous</PaginateButton>

            {firstPageNumber > 1 && <PaginateButton onClick={setStartIndex(0)}>1</PaginateButton>}
            {firstPageNumber > 2 && <span className="ellipsis">…</span>}
            {rangeInclusive(firstPageNumber, lastPageNumber).map(pageNumber => (
                <PaginateButton key={pageNumber}
                    className={{current: state.startIndex === pageNumber - 1}}
                    onClick={setStartIndex(pageNumber - 1)}>{pageNumber}</PaginateButton>
            ))}
            {lastPageNumber <= endIndex - 1 && <span className="ellipsis">…</span>}
            {lastPageNumber <= endIndex &&
                <PaginateButton onClick={setStartIndex(endIndex)}>{endIndex + 1}</PaginateButton>}
            {state.startIndex > endIndex &&
                <PaginateButton onClick={NOOP} disabled className="current">{state.startIndex + 1}</PaginateButton>}

            <PaginateButton className={{next: true}}
                disabled={state.startIndex >= endIndex}
                onClick={setStartIndex(p => p + 1)}>Next</PaginateButton>
        </div>
    )
}
